import { useState, useEffect } from 'react'
import { Clock } from 'lucide-react'

interface LiveTimerProps {
  startTime: number // epoch timestamp
  className?: string
  showIcon?: boolean
}

export function LiveTimer({ startTime, className = '', showIcon = true }: LiveTimerProps) {
  const [elapsed, setElapsed] = useState(0)

  useEffect(() => {
    const updateElapsed = () => {
      const now = Math.floor(Date.now() / 1000)
      setElapsed(Math.max(0, now - startTime))
    }

    updateElapsed()
    const interval = setInterval(updateElapsed, 1000)

    return () => clearInterval(interval)
  }, [startTime])

  const formatElapsed = (seconds: number) => {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${mins}:${secs.toString().padStart(2, '0')}`
  }

  return (
    <span className={`flex items-center gap-1 ${className}`}>
      {showIcon && <Clock className="h-3 w-3" />}
      {formatElapsed(elapsed)}
    </span>
  )
}